<h2 class="mb-4">Ma ligne</h2>
<div class="line-status-container">
  <div class="content">
    <div class="grid">
      <div class="bold-label-text"><strong>État :</strong></div>
      <div class="label">{{ line.status }} <app-dot [className]="'line_dot_status'"></app-dot></div>
    </div>
  </div>
  <div class="content network-container">
    <div class="grid">
      <div class="bold-label-text"><strong>Réseau :</strong></div>
      <div class="capitalize float-left label">{{ line.network }}<img src="../../../../../assets/images/icons/{{ line.network }}.png"></div>
    </div>
  </div>
  <div class="content offer-container">
    <div class="grid">
      <div class="bold-label-text"><strong>Forfait :</strong></div>
      <div class="label">{{ line.offer.labelTunnel }}{{ displaySupportInformation ? '[ID - '+line.offer.id+']' : '' }}</div>
    </div>
  </div>
</div>

@if (status.label || status.details) {
  <div class="line-status-container">
    @if (status.label || status.details) {
      <div class="content">
        <div [innerHTML]="status.label"></div>
        <div [innerHTML]="status.details"></div>
      </div>
    }
  </div>
}

@if (filteredOptions.length > 0) {
  <div [className]="'hr-'+environment.data.brand"></div>
}

@if (filteredOptions.length > 0) {
  <h2>Mes options</h2>
}
@if (filteredOptions.length > 0) {
  <div class="row pt-2 option-grid">
    @for (option of filteredOptions; track option) {
      <div class="col-12 mb-2">
        - {{option.labelEc}}
      </div>
    }
  </div>
}

<div [className]="'hr-'+environment.data.brand"></div>

@if (line.puk1 || line.puk2 || (displaySupportInformation && line.serial && !line.hasEsim)) {
  <h2>Ma SIM</h2>
}
@if (line.statusDetails.deliveredSimDate) {
  <div class="line-status-container">
    <div class="content">
      <div class="grid">
        <div class="bold-label-text">Date d'envoi  :</div>
        <div class="capitalize">{{ line.statusDetails.deliveredSimDate }}</div>
      </div>
    </div>
    <div class="content">
      @if (line.hasEsim) {
        <div class="grid">
          <div class="bold-label-text pointer-cursor underline-text" (click)="displayPopup()">
            <img _ngcontent-uuk-c10="" _ngcontent-cvq-c10="" alt="" height="18" src="https://cdn.prixtel.com/sources/prixtel/images/assets/icon-esim.png" style="margin: -5px 3px 0px 0px">QR code eSIM
          </div>
          <app-esim-qr-code [phoneNumber]="line.phoneNumber"></app-esim-qr-code>
        </div>
      }
    </div>
  </div>
}

@if (line.puk1 || line.puk2 || (displaySupportInformation && line.serial && !line.hasEsim)) {
  <div class="line-status-container">
    @if (line.puk1) {
      <div class="content">
        <div class="grid">
          <div class="bold-label-text">PUK1 :</div>
          <div class="capitalize">{{ line.puk1 }}</div>
        </div>
      </div>
    }
    @if (line.puk2) {
      <div class="content">
        <div class="grid">
          <div class="col-auto bold-label-text">
            <strong>PUK2 :</strong>
          </div>
          <div>{{ line.puk2 }}</div>
        </div>
      </div>
    }
    <div class="content">
      @if (line.serial) {
        <div class="grid">
          <div class="bold-label-text">
            <strong>Numéro SIM :</strong>
          </div>
          <div class="capitalize">{{ line.serial }}</div>
        </div>
      }
    </div>
  </div>
}

@if (line.staticIp) {
  <div class="line-status-container">
    @if (line.staticIp) {
      <div class="content">
        <div class="grid">
          <div class="bold-label-text">
            <strong>IP Fixe :</strong>
          </div>
          <div class="capitalize">{{ line.staticIp }}</div>
        </div>
      </div>
    }
  </div>
}

@if (line.puk1 || line.puk2 || (displaySupportInformation && line.serial && !line.hasEsim)) {
  <div [className]="'hr-'+environment.data.brand"></div>
}

@if (line.offer.offerGt != '' || (environment.data.cgvUrl && environment.data.brand == 'prixtel') || (line.cgv && line.cgv != '' && line.cgv != null) || (line.cga && line.cga != '' && line.cga != null)) {
  <h2>Mes documents</h2>
}
@if (line.offer.offerGt != '') {
  <div>
    <a href="{{ line.offer.offerGt }}" class="file-{{ brand }}" target="_blank">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Guide tarifaire
    </a>
  </div>
}
@if (environment.data.gti) {
  <div>
    <a href="{{ environment.data.gti }}" class="file-{{ brand }}" target="_blank">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Guide tarifaire international
    </a>
  </div>
}
@if (line.cga && line.cga != '' && line.cga != null) {
  <div>
    <a href="{{ line.cga }}" class="file-{{ brand }}" target="_blank">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Condition Générales D’abonnement
    </a>
  </div>
}
@if (line.cgv && line.cgv != '' && line.cgv != null) {
  <div>
    <a href="{{ line.cgv }}" class="file-{{ brand }}" target="_blank">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Conditions Générales De Vente
    </a>
  </div>
}
@if (environment.data.cgvUrl && environment.data.brand == 'prixtel' && !line.cgv) {
  <div>
    <a href="{{ environment.data.cgvUrl }}" class="file-{{ brand }}" target="_blank">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Conditions Générales De Vente
    </a>
  </div>
}
@if (line.offer.contractUrl != null && line.offer.contractUrl != '') {
  <div>
    <a href="{{ line.offer.contractUrl }}" class="file-{{ brand }}" target="_blank">
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Récapitulatif Contractuel
    </a>
  </div>
}
@if (getFiles(FILE_TYPE_SLUG_CONTRACT, true) != null) {
  <div>
    <a (click)="downloadFile(
            getFiles(FILE_TYPE_SLUG_CONTRACT, true).id,
            getFiles(FILE_TYPE_SLUG_CONTRACT, true).filename,
            FILE_TYPE_SLUG_CONTRACT,
            getFiles(FILE_TYPE_SLUG_CONTRACT, true).mimeType
        )
        " class="pointer-cursor"
      >
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Contrat
    </a>
  </div>
}
@if (getFiles(FILE_TYPE_SLUG_RETENTION_CONTRACT, true) != null) {
  <div>
    <a (click)="downloadFile(
            getFiles(FILE_TYPE_SLUG_RETENTION_CONTRACT, true).id,
            getFiles(FILE_TYPE_SLUG_RETENTION_CONTRACT, true).filename,
            FILE_TYPE_SLUG_RETENTION_CONTRACT,
            getFiles(FILE_TYPE_SLUG_RETENTION_CONTRACT, true).mimeType
        )
        " class="pointer-cursor"
      >
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Contrat réengagement
    </a>
  </div>
}
@if (getFiles(FILE_TYPE_SLUG_CHANGE_OFFER_RETENTION_CONTRACT, true) != null) {
  <div>
    <a (click)="downloadFile(
            getFiles(FILE_TYPE_SLUG_CHANGE_OFFER_RETENTION_CONTRACT, true).id,
            getFiles(FILE_TYPE_SLUG_CHANGE_OFFER_RETENTION_CONTRACT, true).filename,
            FILE_TYPE_SLUG_CHANGE_OFFER_RETENTION_CONTRACT,
            getFiles(FILE_TYPE_SLUG_CHANGE_OFFER_RETENTION_CONTRACT, true).mimeType
        )
        " class="pointer-cursor"
      >
      <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> Contrat changement de forfait
    </a>
  </div>
}
@if (getFiles(FILE_TYPE_SLUG_AMENDMENT, false) != null) {
  <div>
    @for (amendment of getFiles(FILE_TYPE_SLUG_AMENDMENT, false); track amendment) {
      <div>
        <a (click)="downloadFile(
                amendment.id,
                amendment.filename,
                FILE_TYPE_SLUG_AMENDMENT,
                amendment.mimeType
            )"
           class="pointer-cursor"
        >
          <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> {{getFileName(amendment.filename, FILE_TYPE_SLUG_AMENDMENT)}}
        </a>
        <br>
        </div>
      }
    </div>
  }
  @if (getFiles(FILE_TYPE_SUBSCRIPTION_KBIS, true) != null) {
    <div>
    <a (click)="downloadFile(
            getFiles(FILE_TYPE_SUBSCRIPTION_KBIS, true).id,
            getFiles(FILE_TYPE_SUBSCRIPTION_KBIS, true).filename,
            FILE_TYPE_SUBSCRIPTION_KBIS,
            getFiles(FILE_TYPE_SUBSCRIPTION_KBIS, true).mimeType
        )"
       class="pointer-cursor"
    >
        <span class="tim-icons icon-cloud-download-93 pr-2 prixtel-color"></span> KBIS
      </a>
    </div>
  }

